<template>
    <div class="common_header">
        <div class="common_header_item" :class="{'common_header_select':item.id == selectId}" v-for="(item,index) in tabList" :key="index" @click="changeTab(item)">{{item.name}}</div>
    </div>
</template>

<script>
export default {
    props:["tabList",'selectTabId'],
   data (){
       return {
           selectId:''
       }
   },
   components: {
       
   },
   watch: {
       
   },
   computed: { 
       
   },
   methods: { 
       changeTab(item){
           if(!this.$listeners.tabChange){
               return
           }
           if(this.selectId == item.id){
               return
           }
           this.selectId = item.id;
           this.$emit("tabChange",this.selectId);
       }
   },
   created() {
       this.selectId = !this.selectTabId ? this.tabList[0].id : this.selectTabId;
   },
   mounted() {
       
   }
}
</script>

<style scoped lang='less'>
.common_header{
    display: flex;
    justify-content:flex-start;
    border-bottom:1px solid #E1E1E1;
    &_item{
        display: inline-block;
        padding: 0 0px 13px 0px;
        width:80px;
        text-align: center;
        font-size:20px;
        font-weight: 600;
        color:#333;
        cursor: pointer;
        margin-left: 20px;
    }
    &_item.common_header_select{
        color:#1F9EFF;
        border-bottom:4px solid #009AFF;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/header_tab.vue